export function formatQuantity(q: string | number): string {
  const n = Number(q);
  return n.toLocaleString('da-DK', { maximumFractionDigits: 3 });
}

export function formatPrice(cents: number | null, currency = 'DKK'): string {
  if (cents === null || cents === undefined) return '';
  return (cents / 100).toLocaleString('da-DK', {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  });
}
